import { ROUTE_ICONS } from "./route-icons";
import { ROUTE_CODES } from "./route-codes";

// whole application modules and submodules routes/paths
// Each Route/Module Shape
//     assignable: false/true, // if module is available to attach with right(s)
//     path: "dummy-path", // path should be a unique string to render components dynamically
//     name: "Dummy Path", // name for the module
//     code: "DUMMY_PATH", // unique code among all modules/routes
//     hide: false/true,   // to hide step (optional)
//     childModules: [] //

//....................................... all modules routes ................................
const DashboardRoutes = [
  {
    assignable: false,
    hide: false,
    path: "dashboard",
    name: "Dashboard",
    code: ROUTE_CODES.DASHBOARD,
    icon: ROUTE_ICONS.DASHBOARD,
    childModules: [],
  },
];
const WizardRoutes = [
  {
    assignable: true,
    hide: false,
    path: "support-plan",
    name: "Support Plan",
    code: ROUTE_CODES.SUPPORT_PLAN,
    icon: ROUTE_ICONS.SUPPORT_PLAN,
    childModules: [
      {
        hide: false,
        path: "support-plan/:clientId",
        name: "Client Support Plan",
        code: ROUTE_CODES.CLIENT_SUPPORT_PLAN,
        icon: ROUTE_ICONS.SUPPORT_PLAN,
        childModules: [
          {
            name: "Name and Contact",
            descr: "Enter the client name and contact information",
            code: ROUTE_CODES.ASSIGNED_CLIENT,
            childModules: [
              {
                assignable: true,
                hide: false,
                path: "assigned-client-tablet-config-tab",
                name: "Tablet Config Tab",
                code: ROUTE_CODES.BTN_ASSIGNED_CLIENT_TABLET_CONFIG_TAB, // it's a tab
                childModules: [],
              },
            ],
          },
          {
            name: "Support Circle",
            descr:
              "Enter Case Managers, Guardians, HPC, County Board and Call Tree Information",
            code: ROUTE_CODES.SUPPORT_CIRCLE,
            childModules: [],
          },
          {
            name: "CS Rep",
            descr: "Enter Client Services Representative",
            code: ROUTE_CODES.CS_REPRESENTATIVE,
            childModules: [],
          },
          {
            name: "Emergency Planning",
            descr:
              "Enter Emergency Contact, Disaster & Emergency Plan Information",
            code: ROUTE_CODES.EMERGENCY_PLANNING,
            childModules: [],
          },
          {
            name: "Personal/Support Detail",
            descr: "Enter personal/support detail",
            code: ROUTE_CODES.PERSONAL_SUPPORT_DETAILS,
            childModules: [],
          },
          {
            name: "Support Plan Actions",
            descr: "Define Support Plan Actions for the Client",
            code: ROUTE_CODES.CARE_PLAN_ACTIONS,
            childModules: [],
          },
          {
            name: "Support Plan Actions Calendar",
            descr: "Enter Support Plan Actions for the Calendar",
            code: ROUTE_CODES.CARE_PLAN_CALENDER,
            childModules: [
              {
                assignable: true,
                hide: false,
                path: "care-plan-future-calender-tab",
                name: "Future Template Tab",
                code: ROUTE_CODES.BTN_CARE_PLAN_FUTURE_CALENDER, // it's a tab
                childModules: [],
              },
              {
                assignable: true,
                hide: false,
                path: "care-plan-archived-calender-tab",
                name: "Archived Template Tab",
                code: ROUTE_CODES.BTN_CARE_PLAN_ARCHIVED_CALENDER, // it's a tab
                childModules: [],
              },
            ],
          },
          {
            hide: true,
            name: "Calendar Heat Map",
            descr: "Calendar Heat Map View",
            code: ROUTE_CODES.CALENDER_HEAT_MAP,
            childModules: [],
          },
          {
            name: "Technology",
            descr: "Add/Remove technologies",
            code: ROUTE_CODES.TECHNOLOGY_DETAILS,
            childModules: [],
          },
          {
            name: "Alert Conditions",
            descr: "Enter Alert Conditions",
            code: ROUTE_CODES.ALERT_CONDITIONS,
            childModules: [],
          },
          {
            name: "Health Information",
            descr: "Enter Health Information for Client",
            code: ROUTE_CODES.HEALTH_INFORMATION,
            childModules: [],
          },
          {
            name: "Generate Support Plan",
            descr: "Generate word document",
            code: ROUTE_CODES.GENERATE_DOCUMENT,
            childModules: [],
          },
          {
            name: "Suspension History",
            descr: "View suspension history",
            code: ROUTE_CODES.SUSPENSION_HISTORY,
            childModules: [],
          },
          {
            name: "Support Plan Acknowledgement History",
            descr: "View Acknowledgement History",
            code: ROUTE_CODES.SUPPORT_PLAN_ACKNOWLEDGEMENT_HISTORY,
            childModules: [],
          },
          {
            name: "Support Plan Individual Version History",
            descr: "Individual Version History",
            code: ROUTE_CODES.SUPPORT_PLAN_INDIVIDUAL_VERSION_HISTORY,
            childModules: [],
          },
          {
            name: "Reported Client Sentiment Scores",
            descr: "View Reported Client Sentiment Scores",
            code: ROUTE_CODES.SATISFACTION_SCORES,
            childModules: [],
          },
          {
            name: "Individual Communications Report",
            descr: "View Individual Communications Report",
            code: ROUTE_CODES.INDIVIDUAL_COMMUNICATIONS_REPORT,
            childModules: [],
          },
          {
            name: "Billing History",
            descr: "View Billing History",
            code: ROUTE_CODES.BILLING_HISTORY,
            childModules: [],
          },
          {
            name: "MUI/UI History",
            descr: "View MUI/UI History",
            code: ROUTE_CODES.MUI_INCIDENT_HISTORY,
            childModules: [],
          },
          {
            name: "Objective / Checklist Report",
            descr: "View Objective / Checklist Report",
            code: ROUTE_CODES.OBJECTIVE_CHECKLIST_REPORT,
            childModules: [],
          },
          {
            name: "Support Note History",
            descr: "View Support Note History",
            code: ROUTE_CODES.SUPPORT_NOTE_HISTORY_AUDIT,
            childModules: [],
          },
        ],
      },
      {
        assignable: true,
        hide: false,
        path: "support-plan",
        name: "Support Plan Templates",
        descr: "support plan templates crud",
        componentName: "TemplateDialog",
        code: "SUPPORT_PLAN_TEMPLATES",
        icon: ROUTE_ICONS.SUPPORT_PLAN,
        childModules: [],
      },
    ],
  },
];
const SuspensionManagerRoutes = [
  {
    assignable: true,
    hide: false,
    path: "suspension-manager",
    name: "Suspension Manager",
    code: ROUTE_CODES.SUSPENSION_MANAGER,
    icon: ROUTE_ICONS.SUSPENSION_MANAGER,
    childModules: [
      {
        assignable: true,
        hide: false,
        path: "add-new-suspension",
        name: "Add New Suspension",
        code: ROUTE_CODES.BTN_ADD_NEW_SUSPENSION, // it's a button
        icon: ROUTE_ICONS.SUSPENSION_MANAGER,
        childModules: [],
      },
      {
        assignable: true,
        hide: false,
        path: "clean-up-removal-queue",
        name: "Clean Up Removal Queue",
        code: ROUTE_CODES.BTN_CLEAN_UP_REMOVAL_QUEUE,
        icon: ROUTE_ICONS.SUSPENSION_MANAGER,
        childModules: [],
      },
    ],
  },
];
const FSToolsRoutes = [
  {
    assignable: true,
    hide: false,
    path: "fs-tools",
    name: "FS Tools",
    code: ROUTE_CODES.FS_TOOLS,
    icon: ROUTE_ICONS.FS_TOOLS,
    childModules: [
      {
        name: "Geocomm Utilities",
        descr: "geocomm utilities",
        path: "geocomm-pendant",
        code: ROUTE_CODES.GEOCOMM_UTILITIES,
        childModules: [
          {
            name: "Geocomm Maintenance",
            descr: "geocomm maintenance",
            path: "geocomm-maintenance",
            code: ROUTE_CODES.GEOCOMM_MAINTENANCE,
            childModules: [],
          },
        ],
      },
      {
        name: "Geocomm Wristband",
        descr: "geocomm wristband",
        path: "geocomm-wristband",
        code: ROUTE_CODES.GEOCOMM_WRISTBAND,
        childModules: [
          {
            name: "Provision GeoComm Device",
            descr: "provision geoComm device",
            path: "provision-device",
            code: ROUTE_CODES.PROVISION_GEOCOMM_DEVICE,
            childModules: [],
          },
          {
            name: "Wristband Contacts",
            descr: "wristband contacts",
            path: "wristband-contacts",
            code: ROUTE_CODES.WRISTBAND_CONTACTS,
            childModules: [],
          },
          {
            name: "Wristband Geofence",
            descr: "wristband geofence",
            path: "wristband-geofence",
            code: ROUTE_CODES.WRISTBAND_GEOFENCE,
            childModules: [],
          },
          {
            name: "Generate Short Token",
            descr: "generate short token",
            path: "short-token-generator",
            code: ROUTE_CODES.GENERATE_SHORT_TOKEN,
            childModules: [],
          },
          {
            name: "Reboot Wristband",
            descr: "reboot wristband",
            path: "reboot-wristband",
            code: ROUTE_CODES.REBOOT_WRISTBAND,
            childModules: [],
          },
        ],
      },
      {
        name: "Shinobi Camera Configuration",
        descr: "shinobi camera configuration",
        path: "shinobi-camera",
        code: ROUTE_CODES.SHINOBI_CAMERA,
        childModules: [
          {
            name: "Shinobi Camera Configuration",
            descr: "shinobi camera configuration",
            path: "shinobi-camera-configuration",
            code: ROUTE_CODES.SHINOBI_CAMERA_CONFIG,
            childModules: [],
          },
          {
            name: "Support Center Tabs Configuration",
            descr: "support center tabs configuration",
            path: "support-center-tabs",
            code: ROUTE_CODES.SUPPORT_CENTER_TABS,
            childModules: [],
          },
        ],
      },
      {
        name: "Foscam Camera Configuration",
        descr: "foscam camera configuration",
        path: "foscam-camera",
        code: ROUTE_CODES.FOSCAM_CAMERA,
        childModules: [
          {
            name: "Foscam Camera Configuration",
            descr: "foscam camera configuration",
            path: "foscam-camera-configuration",
            code: ROUTE_CODES.FOSCAM_CAMERA_CONFIG,
            childModules: [],
          },
        ],
      },
      {
        name: "iGuard Stove",
        descr: "iGuard Stove",
        path: "iguard-stove",
        code: ROUTE_CODES.IGUARD_STOVE,
        childModules: [
          {
            name: "Provision iGuard Device",
            descr: "provision iGuard device",
            path: "provision-iguard-device",
            code: ROUTE_CODES.PROVISION_IGUARD_DEVICE,
            childModules: [],
          },
        ],
      },
      {
        name: "Sensor System Utilities",
        descr: "sensor system utilities",
        path: "sensor-system-utilities",
        code: ROUTE_CODES.SENSOR_SYSTEM_UTILITIES,
        childModules: [
          {
            name: "Provision Sensor System",
            descr: "provision sensor system",
            path: "provision-sensor-system",
            code: ROUTE_CODES.PROVISION_SENSOR_SYSTEM,
            childModules: [],
          },
        ],
      },
      {
        name: "Sensor Status Tools",
        descr: "sensor status tools",
        path: "sensor-status-tools",
        code: ROUTE_CODES.SENSOR_STATUS_TOOLS,
        childModules: [
          {
            name: "Sensor System Message Status",
            descr: "sensor system message status",
            path: "sensor-system-message-status",
            code: ROUTE_CODES.SENSOR_SYSTEM_MESSAGE_STATUS,
            childModules: [],
          },
          {
            name: "Sensor Outage Status",
            descr: "sensor outage status",
            path: "sensor-outage-status",
            code: ROUTE_CODES.SENSOR_OUTAGE_STATUS,
            childModules: [],
          },
          {
            name: "IUS Sensor Status",
            descr: "ius sensor status",
            path: "ius-sensor-status",
            code: ROUTE_CODES.IUS_SENSOR_STATUS,
            childModules: [],
          },
        ],
      },
      {
        name: "Tablet Dashboard",
        descr: "tablet dashboard",
        path: "tablet-dashboard",
        code: ROUTE_CODES.TABLET_DASHBOARD,
        childModules: [
          {
            name: "Battery Level and Online Status",
            descr: "battery level and online status",
            path: "tablet-charts",
            code: ROUTE_CODES.BATTERY_LEVEL,
            childModules: [],
          },
          {
            name: "Device Grid",
            descr: "device grid",
            path: "tablet-grid",
            code: ROUTE_CODES.DEVICE_GRID,
            childModules: [],
          },
        ],
      },
      {
        name: "Tablet Utilities",
        descr: "tablet utilities",
        path: "tablet-utilities",
        code: ROUTE_CODES.TABLET_UTILITIES,
        childModules: [
          {
            name: "Tablet Maintenance",
            descr: "tablet maintenance",
            path: "tablet-maintenance",
            code: ROUTE_CODES.TABLET_MAINTENANCE,
            childModules: [],
          },
          {
            name: "Tablet Users",
            descr: "tablet users",
            path: "tablet-users",
            code: ROUTE_CODES.TABLET_USERS,
            childModules: [],
          },
        ],
      },
    ],
  },
];
const BillingToolsRoutes = [
  {
    assignable: true,
    hide: false,
    path: "billing-tools",
    name: "Billing Tools",
    code: ROUTE_CODES.BILLING_TOOLS,
    icon: ROUTE_ICONS.BILLING_TOOLS,
    childModules: [
      {
        name: "EMBS File Management",
        descr: "EMBS file management",
        path: "embs-file-management",
        code: ROUTE_CODES.EMBS_FILE_MANAGEMENT,
        childModules: [
          {
            name: "Upload Weekly EMBS File",
            descr: "upload weekly EMBS file",
            path: "upload-weekly-embs-file",
            code: ROUTE_CODES.UPLOAD_WEEKLY_EMBS_FILE,
            childModules: [],
          },
          {
            name: "Generate EMBS File From Excel",
            descr: "generate EMBS file from excel",
            path: "generate-embs-submission-file",
            code: ROUTE_CODES.GENERATE_EMBS_SUBMISSION_FILE,
            childModules: [],
          },
          {
            name: "Create EMBS Hours File",
            descr: "create embs hours file",
            path: "create-embs-hours-file",
            code: ROUTE_CODES.CREATE_EMBS_HOURS_FILE,
            childModules: [],
          },
          {
            name: "List Imported Files",
            descr: "list imported files",
            path: "list-imported-files",
            code: ROUTE_CODES.LIST_IMPORTED_FILES,
            childModules: [],
          },
        ],
      },
      {
        name: "Client Billing Management",
        descr: "client billing management",
        path: "embs-client-management",
        code: ROUTE_CODES.EMBS_CLIENT_MANAGEMENT,
        childModules: [
          {
            name: "Edit Billing Parameters",
            descr: "edit billing parameters",
            path: "edit-billing-parameters",
            code: ROUTE_CODES.EDIT_BILLING_PARAMETERS,
            childModules: [],
          },
        ],
      },
      {
        name: "Billing Data",
        descr: "Billing Data",
        path: "billing-data",
        code: ROUTE_CODES.BILLING_DATA,
        childModules: [
          {
            name: "Billing Week Summary",
            descr: "Billing Week Summary",
            path: "billing-week-summary",
            code: ROUTE_CODES.BILLING_WEEK_SUMMARY,
            childModules: [],
          },
        ],
      },
    ],
  },
];
const SensorManagerRoutes = [
  {
    assignable: true,
    hide: false,
    path: "sensor-manager",
    name: "Sensor Manager",
    code: ROUTE_CODES.SENSOR_MANAGER,
    icon: ROUTE_ICONS.SENSOR_MANAGER,
    childModules: [],
  },
];
const AppSettingRoutes = [
  {
    assignable: true,
    hide: false,
    path: "settings",
    name: "Settings",
    code: ROUTE_CODES.SETTINGS,
    icon: ROUTE_ICONS.SETTINGS,
    childModules: [
      {
        name: "Application Settings",
        descr: "Application Settings",
        path: "app-settings",
        code: ROUTE_CODES.APPLICATION_SETTINGS,
        childModules: [
          {
            name: "Special Handling Message Banners ",
            descr: "Special Handling Banners",
            path: "handling-banners",
            code: ROUTE_CODES.SPECIAL_HANDLING_MANAGER,
            childModules: [],
          },
          {
            name: "Global Announcements",
            descr: "Global Announcements",
            path: "global-announcements",
            code: ROUTE_CODES.GLOBAL_ANNOUNCEMENTS,
            childModules: [],
          },
          {
            name: "Communication Methods",
            descr: "Communication Methods",
            path: "communication-methods",
            code: ROUTE_CODES.COMMUNICATION_METHODS,
            childModules: [],
          },
          {
            name: "Command Center Tiles",
            descr: "Command Center Tiles Management",
            path: "command-center-tiles",
            componentName: "CommandCenter/CommandCenterTileList",
            code: "COMMAND_CENTER_TILES",
            childModules: [],
          },
        ],
      },
      {
        name: "User Administration",
        descr: "User Administration",
        path: "user-admin",
        code: ROUTE_CODES.USER_ADMINISTRATION,
        childModules: [
          {
            name: "User Administration Maintenance ",
            descr: "User Administration Maintenance ",
            path: "user-maintenance",
            code: ROUTE_CODES.USER_ADMINISTRATION_MAINTENANCE,
            childModules: [],
          },
          {
            name: "SSO Association Maintenance ",
            descr: "SSO Association Maintenance ",
            path: "sso-maintenance",
            code: ROUTE_CODES.SSO_ASSOCIATION_MAINTENANCE,
            childModules: [],
          },
        ],
      },
      {
        name: "Application Administration",
        descr: "Application Administration",
        path: "app-admin",
        code: ROUTE_CODES.APPLICATION_ADMINISTRATION,
        childModules: [
          {
            name: "User Right(s) Maintenance ",
            descr: "User Right(s) Maintenance ",
            path: "right-maintenance",
            code: ROUTE_CODES.USER_RIGHTS_MAINTENANCE,
            childModules: [],
          },
          {
            name: "User Role(s) Maintenance ",
            descr: "User Role(s) Maintenance ",
            path: "role-maintenance",
            code: ROUTE_CODES.USER_ROLES_MAINTENANCE,
            childModules: [],
          },
          {
            name: "System Tag Maintenance ",
            descr: "System Tag Maintenance  ",
            path: "system-tag-maintenance",
            code: ROUTE_CODES.SYSTEM_TAG_MAINTENANCE,
            childModules: [],
          },
          {
            name: "Language Maintenance ",
            descr: "Language Maintenance  ",
            path: "language-maintenance",
            componentName: "UserAdmin/LanguageMaintenance",
            code: "LANGUAGE_MAINTENANCE",
            childModules: [],
          },
          {
            name: "Tablet Notification Configuration",
            descr: "Tablet Notification Configuration",
            path: "tablet-notification-configuration",
            code: ROUTE_CODES.TABLET_NOTIFICATION_CONFIGURATION,
            childModules: [],
          },
        ],
      },
      {
        name: "Application Logs",
        descr: "Application Logs",
        path: "application-logs",
        code: ROUTE_CODES.APPLICATION_LOGS,
        childModules: [
          {
            name: "Client Support Plan Logs",
            descr: "client user support plan logs",
            path: "support-plan-logs",
            code: ROUTE_CODES.SUPPORT_PLAN_LOGS,
            childModules: [],
          },
          {
            name: "Admin Support Plan Logs",
            descr: "admin user support plan logs",
            path: "admin-user-support-plan-logs",
            code: ROUTE_CODES.ADMIN_USER_SUPPORT_PLAN_LOGS,
            childModules: [],
          },
        ],
      },
      {
        name: "Quality of Life Survey Administration",
        descr: "QoL Survey Administration",
        path: "obj-admin",
        code: ROUTE_CODES.QOL_ADMINISTRATION,
        childModules: [
          {
            name: "Question Maintenance ",
            descr: "Question Maintenance ",
            path: "qol-maintenance",
            code: ROUTE_CODES.QOL_MAINTENANCE,
            childModules: [],
          },
          {
            name: "Answer Maintenance ",
            descr: "Answer Maintenance ",
            path: "answer-maintenance",
            code: ROUTE_CODES.ANSWER_MAINTENANCE,
            childModules: [],
          },
        ],
      },
      {
        name: "Objectives Administration",
        descr: "Objectives Administration",
        path: "obj-admin",
        code: ROUTE_CODES.OBJ_ADMINISTRATION,
        childModules: [
          {
            name: "Objectives Maintenance ",
            descr: "Objectives Maintenance ",
            path: "obj-maintenance",
            code: ROUTE_CODES.OBJECTIVES_MAINTENANCE,
            childModules: [],
          },
        ],
      },
      {
        name: "Checklist Administration",
        descr: "Checklist Administration",
        path: "checklist-admin",
        code: ROUTE_CODES.CHECKLIST_ADMIN,
        childModules: [
          {
            name: "Checklist Maintenance ",
            descr: "Checklist Maintenance ",
            path: "checklist-maintenance",
            code: ROUTE_CODES.CHECKLIST_MAINTENANCE,
            childModules: [],
          },
        ],
      },
      {
        name: "Five9 Administration",
        descr: "Five9 Administartion",
        path: "five9-administration",
        code: ROUTE_CODES.FIVE9_ADMIN,
        childModules: [
          {
            name: "Unverified Number Maintenance",
            desc: "Unverified Number Maintenance",
            path: "unverified-numbers",
            code: ROUTE_CODES.UNVERIFIED_NUMBER_MAINTENANCE,
            childModules: [],
          },
        ],
      },
      {
        name: "Dashboard Administration",
        descr: "Dashboard Administration",
        path: "dashboard-admin",
        code: ROUTE_CODES.DASHBOARD_ADMIN,
        childModules: [
          {
            name: "Dashboard Page Maintenance",
            descr: "Dashboard Page Maintenance",
            path: "dashboard-page-maintenance",
            code: ROUTE_CODES.DASHBOARD_PAGE_MAINTENANCE,
            childModules: [],
          },
          {
            name: "Dashboard Function Maintenance",
            descr: "Dashboard Function Maintenance",
            path: "dashboard-function-maintenance",
            code: ROUTE_CODES.DASHBOARD_FUNCTION_MAINTENANCE,
            childModules: [],
          },
          {
            name: "Dashboard Function Params Options",
            descr: "Dashboard Function Params Options",
            path: "dashboard-function-params-options",
            code: ROUTE_CODES.DASHBOARD_FUNCTION_PARAMS_OPTIONS,
            childModules: [],
          },
          {
            name: "Dashboard Object Types",
            descr: "Dashboard Object Types",
            path: "dashboard-object-types",
            code: ROUTE_CODES.DASHBOARD_OBJECT_TYPES,
            childModules: [],
          },
          {
            name: "Dashboard Page Objects",
            descr: "Dashboard Page Objects",
            path: "dashboard-page-objects",
            code: ROUTE_CODES.DASHBOARD_PAGE_OBJECTS,
            childModules: [],
          },
          {
            name: "Dashboard Page Builder",
            desc: "dashboard page builder",
            path: "dashboard-page-builder",
            code: ROUTE_CODES.DASHBOARD_PAGE_BUILDER,
            childModules: [],
          },
        ],
      },
      {
        name: "Sentiment Scoring Administration",
        descr: "Sentiment Scoring Administration",
        path: "sentiment-admin",
        code: ROUTE_CODES.SENTIMENT_ADMIN,
        childModules: [
          {
            name: "Sentiment Maintenance",
            desc: "Sentiment Maintenance",
            path: "sentiment-maintenance",
            code: ROUTE_CODES.SENTIMENT_MAINTENANCE,
            childModules: [],
          },
        ],
      },
      {
        name: "MUI Report Configuration",
        descr: "MUI Report Configuration",
        path: "mui-config/mui-report-profiles",
        componentName: "",
        code: "MUI_CONFIG",
        childModules: [
          {
            hide: true,
            name: "MUI Report Data Types",
            desc: "MUI Report Data Types",
            path: "mui-report-data-types",
            code: ROUTE_CODES.MUI_REPORT_DATA_TYPES,
            childModules: [],
          },
          {
            hide: true,
            name: "MUI Report Fields",
            desc: "MUI Report Fields",
            path: "mui-report-fields",
            code: ROUTE_CODES.MUI_REPORT_FIELDS,
            childModules: [],
          },
          {
            hide: true,
            name: "MUI Report Tab Config",
            desc: "MUI Report Tab Config",
            path: "mui-report-tab-config",
            code: ROUTE_CODES.MUI_REPORT_TAB_CONFIG,
            childModules: [],
          },
          {
            name: "MUI Report Profiles",
            desc: "MUI Report Profiles",
            path: "mui-report-profiles",
            code: ROUTE_CODES.MUI_REPORT_PROFILES,
            childModules: [],
          },
          {
            name: "MUI Report Profile Tags",
            desc: "MUI Report Profile Tags",
            path: "mui-report-tags",
            code: ROUTE_CODES.MUI_REPORT_TAGS,
            childModules: [],
          },
        ],
      },
      {
        name: "Support Plan Template Administration",
        descr: "support plan template administration",
        path: "support-plan-template-administration",
        componentName: "",
        code: "SUPPORT_PLAN_TEMPLATE_ADMINISTRATION",
        childModules: [
          {
            name: "Template Maintenance",
            desc: "Template Maintenance",
            path: "template-maintenance",
            componentName:
              "SupportPlanTemplateAdministration/TemplateMaintenance/TemplateMaintenance",
            code: "SUPPORT_PLAN_TEMPLATE_MAINTENANCE",
            childModules: [],
          },
        ],
      },
    ],
  },
];
const IUSSensorRoutes = [
  {
    assignable: false,
    hide: false,
    path: "ius-sensor/:externUserCode/:clientName/:agentUsersId/:token",
    name: "IUS Sensor",
    code: ROUTE_CODES.IUS_SENSOR,
    childModules: [],
  },
];
const AuthFromTokenRoutes = [
  {
    assignable: false,
    path: "auth/:usersId",
    code: ROUTE_CODES.AUTH_FROM_TOKEN,
  },
  {
    assignable: false,
    path: "auth/:usersId/:mode",
    code: ROUTE_CODES.AUTH_FROM_TOKEN,
  },
];
const CalendarViewerRoutes = [
  {
    assignable: true,
    hide: false,
    path: "calendar-viewer/:clientId/viewer",
    name: "Calendar Viewer",
    code: ROUTE_CODES.CALENDAR_VIEWER,
    icon: ROUTE_ICONS.CALENDAR_VIEWER,
  },
  {
    assignable: true,
    hide: false,
    path: "calendar-viewer/:clientId/editor",
    name: "Calendar Viewer Editor",
    code: ROUTE_CODES.CALENDAR_VIEWER,
    icon: ROUTE_ICONS.CALENDAR_VIEWER,
  },
];
//................................................................................

const filteredRoutes = [
  ...DashboardRoutes,
  ...WizardRoutes,
  ...SuspensionManagerRoutes,
  ...FSToolsRoutes,
  ...BillingToolsRoutes,
  ...SensorManagerRoutes,
  ...AppSettingRoutes,
  ...IUSSensorRoutes,
  ...CalendarViewerRoutes,
  ...AuthFromTokenRoutes,
].filter((route) => !route.hide);
export const AllRoutes = filteredRoutes;
